// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CrownFilledSvg from "@fishx/icons-svg/es/asn/CrownFilled";
import FishxIcon from '../components/FishxIcon';

var CrownFilled = function CrownFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CrownFilledSvg
  }));
};

CrownFilled.displayName = 'CrownFilled';
export default React.forwardRef(CrownFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CrownFilled.js
// module id = 2350
// module chunks = 0